import React, { useRef } from "react";
import { useGLTF, useVideoTexture } from "@react-three/drei";
import { useCounterStore } from "./stores/CounterStore";

export function TV(props) {
  const { nodes, materials } = useGLTF("TV_FixedUVs.glb");
  // const texture = useVideoTexture("/diosaDelAguaVideo.mp4")
  const texture = useVideoTexture("/videoJC.mp4")
  texture.flipY = false

  const camId = useCounterStore((state) => state.camTransformId)
  const assignCamId = useCounterStore((state) => state.assign)

  return (
    <group {...props} dispose={null}>
      <mesh 
        onClick={() => {
          if(camId == 8) assignCamId(0)
          if(camId == 0) assignCamId(8)          
        }}
        onPointerOver={() => document.body.style.cursor = 'pointer'}
        onPointerOut={() => document.body.style.cursor = 'auto'}
        geometry={nodes.Pantalla.geometry}
        // material={nodes.Pantalla.material}
        position={[0, -0.005, 0.005]}
      >
        <meshBasicMaterial roughness={0.35} map={texture} toneMapped={false} />
      </mesh>
      <mesh 
        geometry={nodes.Television.geometry}
        material={materials.Tele}
        position={[-0.67, 1.53, 0.23]}
        scale={[0.37, 0.22, 0.01]}
      />
    </group>
  );
}

useGLTF.preload("/TV.glb");